// extracted by mini-css-extract-plugin
export default {"container":"cAdXU8BtY"};